import axiosInstance from './PublicAxiosInstance'

export const PublicService = {
  getPublicEventInfo: async () => {
    try {
      const eventData = await axiosInstance.get(`/single-event`)
      return { openDate: eventData.openDate, closeDate: eventData.closeDate, state: eventData.state, questions: eventData.questions }
    } catch (error) {
      /* empty */
    }
  },
}
